import { Avatar, Box, Card, CardContent, Grid2, IconButton, Skeleton, Stack, Typography, useTheme } from "@mui/material";
import Highcharts, { chart } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useEffect, useState } from "react";



const EarnedValueManagements = (props) => {
    const { earnValueData } = props;

    const theme = useTheme();
    const [category, setCategory] = useState([]);
    const [planData, setPlanData] = useState([]);
    const [actualData, setActualData] = useState([]);
    const [earnedData, setEarnedData] = useState([]);

    const categories = ["Jan,24", "Feb,24", "Mar,24", "Apr,24", "May,24"]

    // const actualData = [10, 20, 30, 50, 70];
    // const plannedData = [0, 30, 20, 50, 30];
    // const earnedData = [20, 40, 15, 20, 25];

    useEffect(() => {
        if (earnValueData?.isSuccess) {
            setCategory(earnValueData?.data?.data?.map((item) => item?.month));
            setPlanData(earnValueData?.data?.data?.map((item) => item?.planned > 0 ? item?.planned : null));
            setActualData(earnValueData?.data?.data?.map((item) => item?.actual > 0 ? item?.actual : null));
            setEarnedData(earnValueData?.data?.data?.map((item) => item?.ev > 0 ? item?.ev : null))
        }
    }, [earnValueData])

    const options = {
        chart: {
            height: 350

        },
        title: {
            text: "",
            align: "left",
            style: { fontSize: "24px", fontWeight: "bold", color: "#223365" },
        },

        xAxis: {
            title: { text: "" },
            categories: category,
            lineWidth: 1,
            lineColor: '#758195',
            labels: {
                style: { color: '#414D55', }
            },

        },
        yAxis: {
            title: { text: "" },
            // tickPositions: [0, 20, 40, 60, 80, 100],
            labels: {
                style: { color: '#414D55', }
            },
            min: 0,
            // tickLength: 10,
            tickWidth: 1,
            tickColor: '#999',
            // tickmarkPlacement: 'on',
            gridLineWidth: 1,
            lineWidth: 1,
            lineColor: '#758195',
        },
        tooltip: {
            shared: true,
            useHTML: true,
            backgroundColor: "#00000080",
            shadow: false,
            formatter: function () {
                return ` <b>Actual: ${this.points[0]?.y ?? 0}</b><br/><b>Planned: ${this.points[1]?.y ?? 0}</b><br/><b> Earned: ${this.points[2]?.y ?? 0}</b>`;
            },
            style: {
                color: '#fff'
            }
        },
        plotOptions: {
            series: {
                marker: {
                    enabled: true,
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: false,
                            radius: 5
                        }
                    }
                },
                states: {
                    hover: {
                        lineWidthPlus: 0
                    }
                }
            }
        },
        legend: {
            align: "left",
            verticalAlign: "top",
            layout: "horizontal",
            itemDistance: 20,
            useHTML: true,
            symbolWidth: 0,
            x: -10,
            itemMarginBottom: 16,
            itemMarginTop: 0,
            labelFormatter: function () {
                return `<span style="display:inline-block;width:11px;height:11px;background-color:${this.color};margin:0;margin-right:5px;padding:0;"></span>
                        <span style="font-size:15px;font-weight:500;color:#182A4E;margin:0;padding:0;">${this.name}</span>`;
            }

        },
        series: [
            {
                name: "Actual Cost",
                data: actualData,
                color: "#3E756D",
                lineWidth: 2
            },
            {
                name: "Planned Values",
                data: planData,
                color: "#295477",
                lineWidth: 2
            },
            {
                name: "Earned Values",
                data: earnedData,
                color: "#0840DE",
                lineWidth: 2
            }
        ],
        credits: {
            enabled: false,
        },
    }

    return (
        <>
            <Grid2 size={{ xs: 12, md: 12 }} sx={{ mb: 0, p: 2, }}>
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: "500",
                        fontSize: '18px',
                        color: `${theme?.customSettings?.themeColor}`,
                        lineHeight: '100%',
                        letterSpacing: '-0.4px',

                    }}
                >
                    Earned Value Management
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        fontWeight: "400",
                        fontSize: '14px',
                        color: '#182A4E80',
                        lineHeight: '100%',
                        letterSpacing: '-0.4px',


                    }}
                >
                    Track planned, earned, and actual values to assess project performance and forecast outcomes
                </Typography>
            </Grid2>
            <Grid2 size={{ md: 12 }}>
                {earnValueData?.isLoading &&
                    <Box height={400}>
                        <Skeleton variant="rectangular" height={390} animation="wave" sx={{ borderRadius: 7 }} />
                    </Box>
                }
                {!earnValueData?.isLoading &&
                    <Box sx={{ pl: 1, pr: 1 }} >
                        <HighchartsReact highcharts={Highcharts} options={options} />
                    </Box>
                }

            </Grid2>

        </>

    );

};

export default EarnedValueManagements;
